import COMPANIES from "./ListCompany";

let CONFIG_COMPANY = COMPANIES.CUMBO;

export default CONFIG_COMPANY


// WEBPACK FOOTER //
// ./src/services/myConfig.js